import { zaiChatService } from 'services/zai-chat'

import { ZAI_CHAT_PARAMS_KEY } from './zai.consts'
import type { TPrePromptVariantKey, TZaiChatModuleGenerateZaiChatSrcParams, TZaiPromptButtonVariant } from './zai.types'

class ZaiUtils {
  generateZaiChatSrc({
    workspaceId,
    module,
    language,
    threadId,
    threadPrompt,
    threadPromptPage,
    redirectUrl,
    isZaiRagEnabled,
    theme,
    quickPromptId,
  }: TZaiChatModuleGenerateZaiChatSrcParams) {
    const baseUrl = zaiChatService.baseUrl
    const url = new URL(`${baseUrl}/workspace/${workspaceId}/${module}`)

    if (threadId) {
      url.searchParams.set(ZAI_CHAT_PARAMS_KEY.threadId, threadId)
    }

    if (threadPrompt) {
      url.searchParams.set(ZAI_CHAT_PARAMS_KEY.threadPrompt, threadPrompt)
    }

    if (threadPromptPage) {
      url.searchParams.set(ZAI_CHAT_PARAMS_KEY.threadPromptPage, threadPromptPage)
    }

    if (redirectUrl) {
      url.searchParams.set(ZAI_CHAT_PARAMS_KEY.redirectUrl, redirectUrl)
    }

    if (isZaiRagEnabled) {
      url.searchParams.set(ZAI_CHAT_PARAMS_KEY.ragEnabled, isZaiRagEnabled.toString())
    }

    if (theme) {
      url.searchParams.set(ZAI_CHAT_PARAMS_KEY.theme, theme)
    }

    if (quickPromptId) {
      url.searchParams.set(ZAI_CHAT_PARAMS_KEY.quickPromptId, quickPromptId)
    }

    if (language) {
      url.hash = `#lang=${language}`
    }

    return url.toString()
  }

  isIframeOriginValid(event: MessageEvent, iframeSrc: string) {
    if (!iframeSrc) return false

    const eventOriginObjectUrl = new URL(event.origin)
    const eventOrigin = eventOriginObjectUrl.origin

    const iframeOriginObjectUrl = new URL(iframeSrc)
    const iframeOrigin = iframeOriginObjectUrl.origin

    return eventOrigin === iframeOrigin
  }

  transformPrePromptKeyToVariant(
    key: TPrePromptVariantKey | undefined,
    defaultVariant: TZaiPromptButtonVariant = 'default'
  ): TZaiPromptButtonVariant {
    switch (key) {
      case 'CHRISTMAS':
        return 'christmas'
      default:
        return defaultVariant
    }
  }
}

export const zaiUtils = new ZaiUtils()
